export function minutesToMilliseconds(x: number) {
    return x * 60000; //60000 = 1 minute in milliseconds
}

export function clamp(value: number, min: number, max: number): number {
    return Math.min(Math.max(value, min), max);
}
